export default "__VITE_ASSET__B1ST79he__"